<template>
    <div class="warning">
        <van-overlay class="overlay" :show="show" @click="hidewarning" :z-index="999">
            <div class="warning-wrapper flex-column align-center" @click.stop>
                <img class="warning-header-img" :src="data.cover" alt="" @click="toDetail" />
                <!-- <img class="warning-header-btn" @click="experienceGoldDetail" src="@/assets/images/mine/button.png" alt="" /> -->
            </div>
            <div class="close" @click="hidewarning">
                <img src="@/assets/images/close.png" alt="" />
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: "prizeDraw",

    props: {
        show: {
            type: Boolean,
            default: false,
        },
        content: String,
        data: {
            type: Object,
            default: () => { }
        },

    },

    computed: {
        ...mapGetters({ appEnv: 'getAppEnv' })
    },
    data() {
        return {
            pageImg: this.data.cover,
        };
    },
    methods: {
        handleShowwarning() {
            this.$emit("update:show");
        },
        hidewarning() {
            this.$emit("update:show", false);
        },
        handleConfirm() {
            this.$emit("handleConfirm");
        },
        comfirm() {
            this.$emit("comfirm");
        },

        toDetail() {
            console.log('todetail');
            if (this.appEnv.appEnv == 'miniprogram') {
                wx.miniProgram.navigateTo({
                    url: `/pages/prizeDraw/prizeDraw?appId=${this.data.xcxID}&path=${encodeURIComponent(this.data.xcxUrl)}`,
                });
            }
            else {
                window.location.href = this.data.h5Url
            }
        },
    },
};
</script>

<style lang="less" scoped>
.warning {
    .overlay {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .warning-wrapper {
        width: 100%;
        height: 100%;
        border-radius: 20px;

        // margin-top: -200px;
        .warning-header-img {
            width: 100%;
            height: 100%;
        }
        .warning-header-btn {
            width: 257px;
            height: 73px;
            margin-top: -140px;
            cursor: pointer;
        }
        .warning-result {
            font-size: 36px;
            color: #212121;
            margin: 48px 0;
        }
        .warning-description {
            font-size: 30px;
            color: #616161;
            line-height: 40px;
            padding: 0 38px;
        }
        .warning-confirm-btn {
            width: 512px;
            height: 70px;
            color: #fff;
            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
            margin-top: 50px;
            font-size: 32px;
            padding: 0 38px;
        }
    }
    .close {
        position: absolute;
        bottom: 200px;
        left: 0;
        right: 0;
        margin: auto;
        width: 72px;
        height: 72px;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
